// local imports
import { TestTakerPaymentContext } from 'contexts/test-taker-payment';
import { WizardContext } from 'contexts/wizard';
import { useContext } from 'react';
import { OVERNIGHT_SHIPPING_MAX_ORDERABLE } from 'utils/constants';

type ContextType = EnterpriseWizardContext | TestTakerContext;

const useLineItems = (source?: string) => {
  const Context =
    source === 'enterprise' ? WizardContext : TestTakerPaymentContext;

  const { lineItems, setLineItems } = useContext<ContextType>(Context as React.Context<ContextType>);

  const updateLineItem = (quantity: number, productId: number) => {
    const foundProduct = lineItems.find(
      (item) => item.product_id === productId,
    );

    const products = [...lineItems];
    const productIndex = foundProduct ? products.indexOf(foundProduct) : -1;

    if (productIndex === -1) {
      products.push({ product_id: productId, quantity: Number(quantity) });
    } else {
      products[productIndex] = {
        ...products[productIndex],
        quantity: Number(quantity),
      };
    }

    setLineItems(products);
  };

  const shouldDisableOvernightShipping = () => {
    const orderTotalTestsNumber = lineItems.reduce((total: number, currentItem) => {
      return total + currentItem.quantity;
    }, 0);

    return orderTotalTestsNumber > OVERNIGHT_SHIPPING_MAX_ORDERABLE;
  };

  return {
    lineItems,
    updateLineItem,
    shouldDisableOvernightShipping,
  };
};

export default useLineItems;
